@if (show$$()) {

@if (tabVisible$$()) {
  <div #pagerContainer class="pager-container" @showHeightCollapse>
    <app-filter (onChange)="emit_filterChange()"/>
  </div>
}
<div
    [style.bottom.px]="_pagerHeight$$()"
    [class]="'buttons-box-tab right'"
>
    @if (buttonsShow) {
        <div class="buttons vertical" @show>
            @if (tabVisible$$() && tabPositionOffStandard$$() && !locked$$()) {
                <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_positionReset()"
                [tooltip]="'reset tab position'"
                [tooltipPosition]="'left'"
                >
                    <app-icon name="tab-reset" />
                </app-button-mini-fab>
            }
            @if (tabVisible$$() && sectionDetails_show$$() && btnEditShow$$()) {
                <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_editShow()"
                [disabled]="btnEditDisabled$$()"
                [tooltip]="btnEditTooltip$$()"
                [tooltipPosition]="'left'"
                >
                    <app-icon name="edit" />
                </app-button-mini-fab>
            }
            @if ((tabVisible$$()) && !(filterShow$$())) {
                <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_btnFilterShow()"
                [tooltip]="'open filter section'"
                [tooltipPosition]="'left'"
                >
                    <app-icon name="filter" />
                </app-button-mini-fab>
            }
            @if ((tabVisible$$()) && (filterShow$$())) {
                <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_btnFilterShow()"
                [tooltip]="'close filter section'"
                [tooltipPosition]="'left'"
                >
                    <app-icon name="remove-filter" />
                </app-button-mini-fab>
            }
            @if (tabVisible$$() && !locked$$()) {
                <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_tabHide()"
                [tooltip]="'hide tab section'"
                [tooltipPosition]="'left'"
                >
                    <app-icon name="tab-min" />
                </app-button-mini-fab>
            }
            @if (!(tabVisible$$()) && sectionDetails_show$$()) {
                <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_tabShow()"
                [tooltip]="'show tab section'"
                [tooltipPosition]="'left'"
                >
                    <app-icon name="tab-up" />
                </app-button-mini-fab>
            }
        </div>
    }
</div>

}
